export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Customers List',
      url: '/customers-list',
      icon: 'icon-user',
    },
    {
      name: 'Orders List',
      url: '/orders-list',
      icon: 'icon-basket',
    },
    {
      name: 'Disburses List',
      url: '/disburses-list',
      icon: 'icon-basket',
    },
    {
      name: 'Shippings List',
      url: '/shippings-list',
      icon: 'icon-basket',
    },
    {
      name: 'Deposits',
      url: '/deposits',
      icon: 'icon-wallet',
      children: [
        {
          name: 'Deposits History',
          url: '/deposits/deposits-history',
        },
        {
          name: 'Request Deposit',
          url: '/deposits/request-deposit',
        },
        {
          name: 'Request List',
          url: '/deposits/request-deposits-list',
        },
      ]
    },
    {
      name: 'Incentives',
      url: '/incentives',
      icon: 'icon-wallet',
      children: [
        {
          name: 'Incentives History',
          url: '/incentives/incentives-history',
        },
        {
          name: 'Request Incentive',
          url: '/incentives/request-incentive',
        },
        {
          name: 'Request List',
          url: '/incentives/request-incentives-list',
        },
      ]
    },
    {
      name: 'Update Margin',
      url: '/update-margin',
      icon: 'icon-settings',
    },
  ]
}
